import { createSlice } from '@reduxjs/toolkit';
import { mapCrmHistory } from 'utilities/mapDataChanges';

const defaultOpportunityHistoryState = {
    isViewOpportunityHistoryModalLoading: false,
    isViewOpportunityHistoryModalOpen: false,
    opportunityHistory: null
}

const defaultOpportunityHistoryDetailsState = {
    eventSummaryRowData: null,
    isViewOpportunityHistoryDetailsModalLoading: false,
    isViewOpportunityHistoryDetailsModalOpen: false,
    opportunityEditHistories: null,
    opportunityStatusHistories: null,
    opportunityTaxesHistories: null,
    opportunityCrmSubmissionHistories: null,
    opportunityAllocationHistories: null,
    opportunityCrmReceiptHistories: null,
    opportunityIcbmOrderHistories: null,
    opportunityValuationHistories: null,
    opportunityProformaInputsContainers: null,
    opportunityEventHistories: null,
    opportunity: null,
    opportunityProspects: null,
    opportunityRejectedImports: null,
    opportunityAssignmentHistories: null, 
    opportunityUnderwriteStatusHistories: null, 
    opportunityTransactionOpportunityHistories: null,
    opportunityImportCompHistories: null,
    opportunityImportSaveHistories: null,
    opportunityImportPropMasterHistories: null,
    opportunityImportHomesHistories: null,
    opportunityImportRegionsAndIndicativesHistories: null,
    opportunityImportMarketHistories: null,
    opportunityImportRepairEstimateHistories: null,
    opportunityImportExpectedSalesPriceHistories: null,
    opportunityImportInsuranceHistories: null,
    opportunityAllocationLogs: null,
    opportunityImportLogs: null
}

export const initialState = {
    ...defaultOpportunityHistoryState,
    ...defaultOpportunityHistoryDetailsState
};

const slice = createSlice({
    name: 'opportunityHistorySlice',
    initialState,
    reducers: {
        closeViewOpportunityHistoryDetails: (state) => {
            return {
                ...state,
                ...defaultOpportunityHistoryDetailsState
            }
        },
        closeViewOpportunityDetails: (state) => {
            return {
                ...state,
                ...defaultOpportunityHistoryState
            }
        },
        setOpportunityHistoryTxnOppId: (state, action) => {
            state.opportunityHistoryTxnOppId = action.payload;
        },
        setIsOpportunityHistoryLoading: (state, action) => {
            state.isViewOpportunityHistoryModalLoading = action.payload;
        },
        setIsViewOpportunityHistoryModalOpen: (state, action) => {
            state.isViewOpportunityHistoryModalOpen = action.payload;
        },
        setOpportunityHistory: (state, action) => {
            state.opportunityHistory = action.payload;
        },
        setEventSummaryRowData: (state, action) => {
            state.eventSummaryRowData = action.payload;
        },
        setIsOpportunityHistoryDetailsModalLoading: (state, action) => {
            state.isViewOpportunityHistoryDetailsModalLoading = action.payload;
        },
        setIsOpportunityHistoryDetailsModalOpen: (state, action) => {
            state.isViewOpportunityHistoryDetailsModalOpen = action.payload;
        },
        setOpportunityHistoryDetailsEditHistories: (state, action) => {
            state.opportunityEditHistories = action.payload;
        },
        setOpportunityHistoryDetailsStatusHistories: (state, action) => {
            state.opportunityStatusHistories = action.payload;
        },
        setOpportunityHistoryDetailsTaxesHistories: (state, action) => {
            state.opportunityTaxesHistories = action.payload;
        },
        setOpportunityHistoryDetailsCrmSubmissionHistories: (state, action) => {
            state.opportunityCrmSubmissionHistories = mapCrmHistory(action.payload, false);
        },
        setOpportunityHistoryDetailsAllocationHistories: (state, action) => {
            state.opportunityAllocationHistories = action.payload;
        },
        setOpportunityHistoryDetailsCrmReceiptHistories: (state, action) => {
            state.opportunityCrmReceiptHistories = mapCrmHistory(action.payload, true);
        },
        setOpportunityHistoryDetailsIcbmOrderHistories: (state, action) => {
            state.opportunityIcbmOrderHistories = action.payload;
        },
        setOpportunityHistoryDetailsValuationHistories: (state, action) => {
            state.opportunityValuationHistories = action.payload;
        },
        setOpportunityHistoryProformaInputsContainers: (state, action) => {
            state.opportunityProformaInputsContainers = action.payload;
        },
        setOpportunityEventHistories: (state, action) => {
            state.opportunityEventHistories = action.payload;
        },
        setOpportunity: (state, action) => {
            state.opportunity = action.payload;
        },
        setOpportunityHistoryDetailsProspects: (state, action) => {
            state.opportunityProspects = action.payload;
        },
        setOpportunityHistoryDetailsRejectedImports: (state, action) => {
            state.opportunityRejectedImports = action.payload;
        },
        setOpportunityHistoryDetailsAssignmentHistory: (state, action) => {
            state.opportunityAssignmentHistories = action.payload;
        },
        setOpportunityHistoryDetailsUnderwriteStatusHistory: (state, action) => {
            state.opportunityUnderwriteStatusHistories = action.payload;
        },
        setOpportunityHistoryTransactionOpportunityHistories: (state, action) => {
            state.opportunityTransactionOpportunityHistories = action.payload;
        },
        setOpportunityHistoryDetailsCompHistories: (state, action) => {
            state.opportunityImportCompHistories = action.payload;
        },
        setOpportunityHistoryDetailsImportSaveHistories: (state, action) => {
            state.opportunityImportSaveHistories = action.payload;
        },
        setOpportunityHistoryDetailsImportPropMasterHistories: (state, action) => {
            state.opportunityImportPropMasterHistories = action.payload;
        },
        setOpportunityHistoryDetailsImportHomesHistories: (state, action) => {
            state.opportunityImportHomesHistories = action.payload;
        },
        setOpportunityHistoryDetailsRegionsAndIndicativesHistories: (state, action) => {
            state.opportunityImportRegionsAndIndicativesHistories = action.payload;
        },
        setOpportunityHistoryDetailsMarketHistories: (state, action) => {
            state.opportunityImportMarketHistories = action.payload;
        },
        setOpportunityHistoryDetailsReapirEstimateHistories: (state, action) => {
            state.opportunityImportRepairEstimateHistories = action.payload;
        },
        setOpportunityHistoryDetailsExpectedSalesPriceHistories: (state, action) => {
            state.opportunityImportExpectedSalesPriceHistories = action.payload;
        },
        setOpportunityHistoryDetailsInsurancesHistories: (state, action) => {
            state.opportunityImportInsuranceHistories = action.payload;
        },
        setOpportunityHistoryDetailsAllocationLogs: (state, action) => {
            state.opportunityAllocationLogs = action.payload;
        },
        setOpportunityHistoryDetailsImportLogs: (state, action) => {
            state.opportunityImportLogs = action.payload;
        },
        fetchOpportunityHistory: () => { }, // getOpportunityHistorySaga
        fetchOpportunityHistoryTableDetails: () => { }, // getOpportunityHistoryTableDetailsSaga
        fetchOpportunityHistoryLogDetails: () => { }, // getOpportunityHistoryLogDetailsSaga
    }
});

export default slice.reducer;

export const opportunityHistoryActions = slice.actions;